import Paper from "material-ui/Paper";

export default Paper;



// WEBPACK FOOTER //
// ./src/components/uielements/paper/index.js